<template>
  <div class="home" ref="homePage">
    <header-mod></header-mod>

    <div class="banner">
      <div class="banner_box">
        <p class="title">怡亚数科供应链小微金融</p>
        <p class="slogan">为您的生意财富之旅保驾护航</p>
      </div>
    </div>

    <ul class="feature_box">
      <li>
        <p class="tip">额度最高500万</p>
        <p class="tit">额度高</p>
      </li>
      <li>
        <p class="tip">最快1分钟到账</p>
        <p class="tit">放款快</p>
      </li>
      <li>
        <p class="tip">线上申请免抵押</p>
        <p class="tit">门槛低</p>
      </li>
      <li>
        <p class="tip">随借随还，按日计息</p>
        <p class="tit">随借随还</p>
      </li>
    </ul>

    <div class="intro_box">
      <div class="intro_title"> 专业供应链小微金融平台 </div>
      <div class="intro_detail"> 怡信未来（怡亚数科）科技有限公司专注于供应链场景，连接银行等各类金融机构，整合平台商户资源，为供应链平台下游小微企业提供基于供应链场景的信贷产品，致力于为更多中小微企业主提供金融服务。 </div>
      <div class="intro_main">
        <div class="intro_item">
          <img src="../assets/imgs/pic1.jpg" alt="">
          <div class="content">
            <p class="tit">助力小微企业蓬勃发展</p>
            <p class="text">为破解小微企业广泛面临的“轻资产、无担保”融资难题，我们连接银行等各类金融机构，提供专业智能线上无抵押贷款服务，让金融活水源源不断的精准滴灌小微企业，有效降低金融服务的门槛和成本。此外，我们还为客户提供技术、产品、资源、信息咨询等商业服务，致力于为更多中小微企业主提供全流程金融服务。</p>
          </div>
        </div>
        <div class="intro_item f_a_b">
          <div class="content">
            <p class="tit">拥有智能金融科技力量</p>
            <p class="text">通过智能决策引擎，根据客户风险度实现动态定额定价，为经营决策分析提供实时精准支持。基于供应链真实交易场景，依托交易链条中商流、物流、资金流和信息流数据，以强大风控体系配合金融科技力量，打造供应链垂直细分行业场景的智能大数据贷款，为快消品行业平台客户提供全流程线上化智能金融服务。</p>
          </div>
          <img src="../assets/imgs/pic2.jpg" alt="">
        </div>
      </div>
    </div>

    <div class="product_box">
      <div class="mod_title">产品介绍</div>
      <div class="product_main">
        <div class="product_intro">
          <div class="tit"> <span> EA生意小助手 </span></div>
          <div class="text">EA生意小助手是一款供应链垂直细分行业场景的智能大数据贷款，最高500万，随借随还，最低日息万3.5、月综合费率最低0.59%，秒级到账。</div>
        </div>
        <img src="../assets/imgs/iphoneEA.png" alt="">
        <ul class="intro_list">
          <li>
            <p class="tit">2分钟完成申请</p>
            <p class="tip">仅需5步骤，最快2分钟，即可完成申请获得信用额度。</p>
          </li>
          <li>
            <p class="tit">最高500万</p>
            <p class="tip">无需抵押，根据用户信用评估情况和每半年动态调整额度，额度内随时支取，额度根据还款实时恢复并可支取。</p>
          </li>
          <li>
            <p class="tit">随借随还</p>
            <p class="tip">按日计息，提前全额还款免手续费，额度内等额本息、等额本金两种产品。</p>
          </li>
          <li>
            <p class="tit">风险定价</p>
            <p class="tip">信用资质越好，综合息费越低，最低日息万3.5、最低月综合息费率0.59%。</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="bank_box">
      <div class="mod_title">合作机构</div>
      <ul>
        <li> <img src="../assets/imgs/zxLogo.png" alt=""> </li>
        <li> <img src="../assets/imgs/sxlogo.png" alt="" style="height: 28px;"> </li>
        <li> <img src="../assets/imgs/bbwlogo.png" alt=""> </li>
        <li> <img src="../assets/imgs/kjlogo.png" alt="" style="height: 48px;"> </li>
        <li> <img src="../assets/imgs/qslogo.jpg" alt="" style="height: 30px;"> </li>
        <!-- <li> <img src="../assets/imgs/tjlogo.png" alt="" style="height: 30px;"> </li> -->
        <li> <img src="../assets/imgs/pflogo.png" alt="" style="height: 44px;"> </li>
        <li> <img src="../assets/imgs/jnlogo.jpg" alt="" style="height: 36px;"> </li>

        <li> <img src="../assets/imgs/ks_log.jpg" alt="" style="height: 96px;"> </li>
        <li> <img src="../assets/imgs/shrb.jpg" alt="" style="height: 96px;"> </li>
        <li> <img src="../assets/imgs/sn_log.png" alt="" style="height: 36px;"> </li>
        <li> <img src="../assets/imgs/zgc_log.png" alt="" style="height: 36px;"> </li>
<!--        <li> <img src="../assets/imgs/jjlogo.png" alt="" style="height: 36px;"> </li>-->
<!--        <li> <img src="../assets/imgs/hxlogo.png" alt=""> </li>-->
      </ul>
    </div>

    <div class="back_top" v-if="showTopBtn" @click="goTop">
      <img src="../assets/imgs/icon_jt_top.png" alt="">
    </div>

    <footer-mod></footer-mod>
  </div>
</template>

<script>
import headerMod from "@/components/header"
import footerMod from "@/components/footer"
export default {
  components: {
    HeaderMod: headerMod,
    FooterMod: footerMod
  },
  data() {
    return {
      showTopBtn: false
    }
  },
  methods: {
    // 滚动页面
    handleScroll() {
      if (this.$refs.homePage.getBoundingClientRect().top < -800) {
        this.showTopBtn = true
      } else {
        this.showTopBtn = false
      }
    },
    goTop() {
      document.documentElement.scrollTop = 0
    }
  },
  created() {
    document.title = '首页 - 怡信未来科技'
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true)
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/index.vue